import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik } from 'formik'
import * as Yup from 'yup'
import useSWR, { mutate } from 'swr'
import { authRequest } from './api'
import { InputField, SubmitButton } from './Form'

import storage from './storage'

function Login() {
  const { data: profile } = useSWR('pxmusic_admin', storage)
  let history = useHistory()
  const [error, setError] = useState(null)
  const inputRef = useRef(null)
  async function onSubmit(values) {
    authRequest(`/login`, {
      method: 'POST',
      body: JSON.stringify(values),
    })
      .then((updatedProfile) => {
        mutate('pxmusic_admin', { ...profile, ...updatedProfile }, false)
        window.localStorage.setItem(
          'pxmusic_admin',
          JSON.stringify(updatedProfile)
        )
        setTimeout(() => history.replace('/'), 300)
      })
      .catch(setError)
  }

  useEffect(() => {
    if (profile && profile.token) {
      history.replace('/')
    }
  }, [profile, history])

  useEffect(() => {
    inputRef.current.focus()
  }, [])

  return (
    <section className="wrapper">
      <div className="topbar" style={{ width: '30vw' }}>
        <h1 style={{ textTransform: 'capitalize' }}>Login</h1>
      </div>
      <div className="json-form" style={{ width: '30vw' }}>
        <Formik
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          initialValues={{ username: '', password: '' }}
          validateOnBlur
          validateOnChange
          enableReinitialize
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <InputField
                name="username"
                placeholder="Username"
                ref={inputRef}
              />
              <InputField
                name="password"
                type="password"
                placeholder="Password"
              />
              <SubmitButton />
              {error}
            </form>
          )}
        </Formik>
      </div>
    </section>
  )
}

export default Login

const validationSchema = Yup.object().shape({
  username: Yup.string().required('Username is Required'),
  password: Yup.string().required('Password is Required'),
})
